export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_en.d59172246398cc8f.json"